import { jsx as _jsx } from "preact/jsx-runtime";
function Ticket(props) {
    const { height, width } = props;
    return (_jsx("svg", { ...props, width: height ?? 27, height: width ?? 27, viewBox: "0 0 27 27", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", children: _jsx("path", { d: "M2.45,19.69c1.3-1.3,3.38-1.31,4.66-.03,1.28,1.28,1.26,3.37-.03,4.66l2.31,2.31,11.31-11.31L11.45,6.06,.14,17.38l2.31,2.31Zm19.28-5.4l4.63-4.63-2.31-2.31c-1.22,1.22-3.25,1.18-4.53-.1-1.28-1.28-1.32-3.31-.1-4.53L17.11,.41l-4.63,4.63,9.26,9.26Z", fillRule: "evenodd" }) }));
}
Ticket.defaultProps = {
    fill: '#fff',
};
export default Ticket;
